export const supportedLanguages = [
  { value: "en", label: "English" },
  { value: "es", label: "Spanish" },
  { value: "zh", label: "Chinese (Mandarin)" },
  { value: "fr", label: "French" },
  { value: "ar", label: "Arabic" },
  { value: "ru", label: "Russian" },
  { value: "hi", label: "Hindi" },
  { value: "bn", label: "Bengali" },
  { value: "pt", label: "Portuguese" },
  { value: "de", label: "German" },
  { value: "ja", label: "Japanese" },
  { value: "ko", label: "Korean" },
  { value: "ur", label: "Urdu" },
  { value: "sw", label: "Swahili" },
  { value: "it", label: "Italian" },
  { value: "tr", label: "Turkish" },
  { value: "fa", label: "Persian (Farsi)" },
  { value: "vi", label: "Vietnamese" },
  { value: "tl", label: "Tagalog (Filipino)" },
  { value: "pl", label: "Polish" },
  { value: "ta", label: "Tamil" },
  { value: "te", label: "Telugu" },
  { value: "ms", label: "Malay" },
  { value: "id", label: "Indonesian" },
  { value: "th", label: "Thai" },
  { value: "pa", label: "Punjabi" },
  { value: "gu", label: "Gujarati" },
  { value: "nl", label: "Dutch" },
  { value: "el", label: "Greek" },
  { value: "cs", label: "Czech" },
  { value: "ro", label: "Romanian" },
  { value: "hu", label: "Hungarian" },
  { value: "ht", label: "Haitian Creole" },
  { value: "am", label: "Amharic" },
  { value: "so", label: "Somali" },
  { value: "yue", label: "Chinese (Cantonese)" },
  { value: "he", label: "Hebrew" },
  { value: "sr", label: "Serbo-Croatian" },
  { value: "my", label: "Burmese" },
  { value: "ne", label: "Nepali" },
  { value: "ps", label: "Pashto" },
];
